export default function formatDateFilter(filter) {
  if (filter) {
    const result = {};
    // 'gte' - дата начала периода, 'lte' - дата конца периода
    const start = filter.filters.find((f) => f.operator === "gte");
    const end = filter.filters.find((f) => f.operator === "lte");
    if (start) {
      result.start = start.value;
    }
    if (end) {
      result.end = end.value;
    }
    return result;
  }
  return null;
}
